//---------------- IMPORTAÇÃO DO COMPONENTE APP ROUTES ----------------//
import AppRoutes from "./routes"; // Componente responsável pelo fluxo de rotas


//---------------- COMPONENTE APP ----------------//
function App() {

  //---------------- RETORNO DO COMPONENTE APP ----------------//
  return <AppRoutes />; // Está sendo retornado o componente AppRoutes, responsável pelo fluxo de rotas

}


//---------------- EXPORTAÇÃO DO COMPONENTE APP ----------------//
export default App;
